import { fr, enUS } from "date-fns/locale";
import i18n from "@libs/i18n";

export function getDateLocale() {
  return i18n.language === "fr" ? fr : enUS;
}

export function getLocaleString(): string {
  return i18n.language === "fr" ? "fr" : "en";
}
